module.exports = __webpack_public_path__ + "static/project-antibiotics-2-ce667db4bb3ed9db82bf92556f445ce9.jpeg";